import React from 'react';
import './DashboradProductTable.scss';

const DashboradProductTable = ({ data }) => {
  const half = Math.ceil(data.length / 2);
  const firstHalf = data.slice(0, half);
  const secondHalf = data.slice(half);

  const renderTable = (items) => (
    <div className="table__box">
      <div className="table__header">
        <div className="header__cell">کد محصول</div>
        <div className="header__cell">نام محصول</div>
        <div className="header__cell">ارزش</div>
      </div>
      <div className="table__body">
        {items.map((item, index) => (
          <div className="table__row" key={index}>
            <div className="table__cell">{item.code}</div>
            <div className="table__cell">{item.title}</div>
            <div className="table__cell">
              {Number(item.value).toLocaleString('fa-IR')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section className='dashbord__type__12__table'>
      <h2>قیمت تمام شده محصولات</h2>
      {data.length > 0 ? (
        <div className='table__grid'>
          {renderTable(firstHalf)}
          {renderTable(secondHalf)}
        </div>
      ) : (
        <div className="text-center p-4 border rounded-3 bg-light">
          <p className="text-muted">دیتایی برای نمایش قیمت تمام شده محصولات وجود ندارد.</p>
        </div>
      )}
    </section>
  );
};

export default DashboradProductTable;
